<template>
    <path fill-rule="evenodd" d="M32 7.563c0-.355-.126-.876-.375-1.563-.25-.687-.938-1.187-2.063-1.5L6.968 0C6.156 0 5.453.292 4.86.875c-.593.583-.89 1.291-.89 2.125v4h-1c-.813.02-1.511.323-2.094.906S0 9.187 0 10v16c0 .834.292 1.542.875 2.125S2.166 29 3 29h26c.833 0 1.542-.292 2.125-.875S32 26.834 32 26V7.562zM5.968 3c0-.27.089-.5.266-.688.177-.187.401-.291.672-.312L28.97 6.469l-.187.28c-.125.188-.386.272-.782.25H5.97V3zM30 26c0 .271-.1.506-.297.703-.199.198-.433.298-.703.298H3c-.27 0-.505-.1-.703-.298-.198-.198-.297-.432-.297-.702V10c0-.272.099-.506.297-.704C2.495 9.1 2.729 9 3 9h25c.48 0 .932-.083 1.36-.25.427-.166.64-.416.64-.75v18zM6 16c-.563 0-1.037.198-1.422.594C4.193 16.99 4 17.459 4 18c0 .563.193 1.037.578 1.422.385.386.86.578 1.422.578.541 0 1.01-.192 1.406-.578.396-.385.594-.86.594-1.422 0-.541-.198-1.01-.594-1.406C7.01 16.198 6.542 16 6 16z"/>
</template>

<script>
export default {
    name: 'walletIcon',
    beforeMount() {
        this.$parent.$emit('size', '0 0 32 29');
    }
}
</script>
